import Http  from "./../utils/Http";
import Urls from "./Urls";

const UserService = {
	
    createUser: async function(user) {
        return await Http.postData(Urls.CREATE_USER, user);
    },
    
    
    emailExists: async function(email) {
        return await Http.postData(Urls.EMAIL_EXISTS, {  "email":email});
    },
    
    phoneExists: async function(phone) {
        return await Http.postData(Urls.PHONE_EXISTS, {  "phone":phone});
    }
    
};

export default UserService;